import { useEffect, useState } from 'react';
import DealForm from './dealForm';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import { useLocation, useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import apiServices from '../../services/service';
import Loader from '../../shared/component/Loader';
import { fetchDataAndUpdateStore, singleRowAddUpdateInStore } from '../../redux/actions';
import { getGridDataByModuleKey, getUser } from '../../redux/selector';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import { dropdownPayload, opportunityInputData } from '../../shared/constants';
import { validationSchemaDeal } from './validationSchema';
import { initValueOpportunity } from '../../shared/initials';

const AddDeals = () => {
  const [formData, setFormData] = useState(initValueOpportunity);
  const [errorMsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [imagefile, setImageFile] = useState(null);
  const stateData = useSelector((state) => state);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector(getUser);
  const [contactOptions, setContactOptions] = useState([]);

  // Update owner in initValueLead if it is an empty string
  if (initValueOpportunity && !initValueOpportunity.owner) {
    initValueOpportunity.owner = userInfo?.user?.display_name;
    initValueOpportunity.ownerId = userInfo?.user?.userId;
  }

  const gridData = useSelector(getGridDataByModuleKey('opportunityList'));

  let storeLoading = isLoadingByKey(
    stateData,
    'revenueTypeList',
    'leadSourceList',
    'industryList',
    'accountList',
    'contactList'
  );

  const [loading, setLoading] = useState(storeLoading);
  const handleCloseAddForm = () => {
  if (location?.state?.from) {
    navigate(-1);  // e.g., /opportunity/viewOpportunity
  } else {
    navigate('/opportunity'); // default fallback
  }
};

  const handleUploadImage = async (imagefile) => {
    setImageFile(imagefile);
    setFormEdited(true);
  };

  const saveUploadImage = async (id) => {
    if (imagefile && id) {
      const newFile = new File([imagefile], id.data, {
        type: imagefile.type,
      });
      let status = await apiServices.uploadLeadImageCRM(newFile, 'Opportunity');
    }
  };

  const editUploadImage = async (id) => {
    if (imagefile && id) {
      const newFile = new File([imagefile], id, {
        type: imagefile.type,
      });
      let status = await apiServices.uploadLeadImageCRM(newFile, 'Opportunity');
    }
  };

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    let convertedValue = value;

    if (['expectedRevenue', 'probability', 'amount'].includes(name)) {
      // If field is cleared, store null
      if (value.trim() === '') {
        convertedValue = null;
      } else {
        let numericString = value.replace(/[^0-9.]/g, '');

        const decimalParts = numericString.split('.');
        if (decimalParts.length > 2) {
          numericString = decimalParts[0] + '.' + decimalParts.slice(1).join('');
        }

        if (numericString.includes('.')) {
          const [intPart, decimalPart = ''] = numericString.split('.');
          numericString = intPart + '.' + decimalPart.slice(0, 2);
        }

        let floatValue = parseFloat(numericString);
        if (isNaN(floatValue) || floatValue < 0) {
          floatValue = null;
        }

        if (name === 'probability' && floatValue > 100) {
          setErrorMsg((prevErrorMsg) => ({
            ...prevErrorMsg,
            probability: 'Probability cannot be greater than 100%',
          }));
          return; // Stop update
        }

        convertedValue = floatValue;
      }
    }

    // Clear error for the edited field
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    setFormData((prevData) => ({
      ...prevData,
      [name]: convertedValue,
    }));

    setFormEdited(true);
  };

  const fetchContactsByAccountId = (accountId) => {
    const data = {
      moduleName: 'Account',
      id: accountId,
    };
    setLoading(true);
    apiServices
      .getContactByModule(data) // Replace with your actual API method
      .then((res) => {
        if (res.status === 200) {
          setContactOptions(res.data.contacts || []);
        } else {
          setContactOptions([]);
        }
      })
      .catch(() => {
        setContactOptions([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    if (name === 'revenueTypeId') {
      setFormData({
        ...formData,
        revenueTypeId: selectedId,
        revenueType: selectedValue,
      });

      setFormEdited(true);
    } else if (name === 'leadSourceId') {
      setFormData({
        ...formData,
        leadSourceId: selectedId,
        leadSource: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'industryId') {
      setFormData({
        ...formData,
        industryId: selectedId,
        industry: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'accountId') {
      setFormData({
        ...formData,
        accountId: selectedId,
        accountName: selectedValue,
        contactId: '', // Reset contact
        contactName: '',
      });
      setSelectedOptions((prev) => ({
        ...prev,
        contactId: null, // Reset contact selection
      }));
      setFormEdited(true);

      // ✅ Fetch contacts for selected account
      fetchContactsByAccountId(selectedId);

      setFormEdited(true);
    } else if (name === 'contactId') {
      setFormData({
        ...formData,
        contactId: selectedId,
        contactName: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'stageId') {
      setFormData({
        ...formData,
        stageId: selectedId,
        stage: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'projectTypeId') {
      setFormData({
        ...formData,
        projectTypeId: selectedId,
        projectType: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'forecastCategoryId') {
      setFormData({
        ...formData,
        forecastCategoryId: selectedId,
        forecastCategory: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'ownerId') {
      setFormData({
        ...formData,
        ownerId: selectedId,
        owner: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'campaignSourceId') {
      setFormData({
        ...formData,
        campaignSourceId: selectedId,
        campaignSource: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'reachOutForMarketingId') {
      setFormData({
        ...formData,
        // reachOutForMarketingId: selectedId,
        reachOutForMarketing: selectedId,
      });
      setFormEdited(true);
    }
  };

  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target; // Use 'checked' for true/false value

    // If it's the reachOutForMarketing checkbox, handle toggle logic
    if (name === 'reachOutForMarketing') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: checked, // Update the value as true/false based on the checked state
      }));
    }

    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined, // Clear any existing error for this field
    }));

    setFormEdited(true); // Mark the form as edited
  };

  const updateList = async (msg, id) => {
    setLoading(false);
    toast.success(msg, {
      position: 'top-right',
    });
    try {
      // ✅ Await the dispatch before navigation
      // await dispatch(
      //   fetchDataAndUpdateStore({
      //     key: "opportunityList",
      //     inputData: opportunityInputData,
      //   })
      // );
      dispatch(
        singleRowAddUpdateInStore({
          moduleName: 'Opportunity',
          id: formData.type === 'add' ? id : formData.id,
          rowIndex: formData.rowIndex,
        })
      );
      dispatch(
        fetchDataAndUpdateStore({
          key: 'opportunityDropdown',
          inputData: dropdownPayload,
        })
      );
      if (formData.from === 'view') {
        navigate(
          `/opportunity/viewOpportunity?id=${formData.id}&pageNo=${gridData?.inputPayload?.pageNumber}`
        );
      } else {
        navigate('/opportunity');
      }
    } catch (error) {
      console.error('Failed to fetch and update Opportunity:', error);
      toast.error('Something went wrong while updating the list.', {
        position: 'top-right',
      });
    }
  };

  const handleFormSubmit = (formData) => {
    setLoading(true);
    if (formData.type === 'add') {
      const sanitizedFormData = { ...formData };
      delete sanitizedFormData.type;
      apiServices
        .createOpportunityList(sanitizedFormData)
        .then((response) => {
          if (response.status === 200) {
            const id = response.data;
            saveUploadImage(response);
            updateList('Opportunity created successfully!', id);
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            Object.keys(errors).forEach((errorType) => {
              const errorMessages = errors[errorType];
              errorMessages.forEach((errorMessage) => {
                // Display each error message in the toaster
                toast.error(` ${errorMessage}`, {
                  position: 'top-right',
                });
              });
            });
          }
          setLoading(false);
        });
    } else {
      editUploadImage(formData.id);
      const sanitizedFormData = { ...formData };
      delete sanitizedFormData.type;
      apiServices
        .updateOpportunityList(sanitizedFormData)
        .then((response) => {
          if (response.status === 200) {
            updateList('Opportunity updated successfully!');
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            Object.keys(errors).forEach((errorType) => {
              const errorMessages = errors[errorType];
              errorMessages.forEach((errorMessage) => {
                // Display each error message in the toaster
                toast.error(` ${errorMessage}`, {
                  position: 'top-right',
                });
              });
            });
          }
          setLoading(false);
        });
    }
  };

  const handleSubmit = async (formData) => {
    try {
      await validationSchemaDeal.validate(formData, { abortEarly: false });

      handleFormSubmit(formData);
    } catch (error) {
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      console.error('Validation Error:', fieldErrors);
    }
  };

  useEffect(() => {
    let updatedFormData = {
      ...formData,
      type: location.pathname.includes('addOpportunity') ? 'add' : 'edit',
    };
    if (location.pathname.includes('editOpportunity') && location.state) {
      updatedFormData = {
        ...location.state,
        type: 'edit',
      };
    }
    setFormData(updatedFormData);
  }, [location]);

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  return (
    <>
      {loading && <Loader />}
      <div className="addlead_container">
        <div className="viewHeader viewshadow">
          <HeaderProfileBlock
            localData={formData}
            moduleName={'Opportunity'}
            uploadFile={handleUploadImage}
          />

          <div className="rightAction">
            <button
              type="button"
              className="btn btn-outline-primary"
              data-bs-dismiss="modal"
              onClick={handleCloseAddForm}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handleSubmit(formData);
              }}
              disabled={loading || (formData.type === 'edit' && !formEdited)}
            >
              {loading && (
                <>
                  {' '}
                  <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                </>
              )}
              {loading ? 'Loading...' : 'Save'}
            </button>
          </div>
        </div>
        <DealForm
          formData={formData}
          selectedOptions={selectedOptions}
          handleSubmit={handleSubmit}
          handleChangeForm={handleChangeForm}
          handleChangeCheckbox={handleChangeCheckbox}
          handleChange={handleChange}
          errormsg={errorMsg}
          contactOptions={contactOptions}
        />
      </div>
    </>
  );
};

export default AddDeals;
